<template>
  <div class="card">
    <loading v-if="loading" :active="loading">
      <slot></slot>
    </loading>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
  import { Loading } from '@/ui/components/Loading';

  export default {
    name: 'Card',
    components: { Loading },
    props: {
      loading: { type: Boolean, default: false }
    },
  };
</script>
